import BasePopup from '../Base/BasePopup';

export default BasePopup;



// WEBPACK FOOTER //
// ./src/Popup/MultiplePopup.jsx